// Market demo data layer: typed fixtures + mutators for the in-memory fake API.
// Everything lives in module state for the tab session; reload resets it.

import { resetBaskets } from './basket';
import { resetCatalog } from './catalog';
import { resetNotifications } from './notifications';
import { resetOrganizations } from './organizations';
import { resetPickups } from './pickups';
import { resetPreOrders } from './preOrders';
import { resetUsers } from './users';

let initialized = false;

/** Rebuild every demo store from the shared story (order matters: later stores read earlier ones). */
export function resetDemoData(): void {
  resetCatalog();
  resetBaskets();
  resetOrganizations();
  resetUsers();
  resetPickups();
  resetPreOrders();
  resetNotifications();
  initialized = true;
}

/** Build the stores on first use, so a real (non-demo) session never pays for them. */
export function ensureDemoData(): void {
  if (!initialized) resetDemoData();
}

export * from './errors';
export * from './catalog';
export * from './basket';
export * from './organizations';
export * from './users';
export * from './pickups';
export * from './preOrders';
export * from './deliveries';
export * from './fulfillment';
export * from './notifications';
